import { OOTimeRanges } from "./OOTimeRanges.entity";

export class OOIntegratorPrice {
	pk: string; //venueKey string
	sk: string; //IP_{name}
	venueKey: number;
	key: string;
	name: string;
	itemPrice: number;
	modifierPrice: number;
	timeRangeKey: string;

	OOTimeRange: OOTimeRanges[];

	public constructor(init?: Partial<OOIntegratorPrice>) {
		Object.assign(this, init);
	}
}
